import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { Key_enrollments, Key_subscriptions } from "../utils/constants";
import {getSubscriptionsByStudent  } from "../services/school/student/getSubscriptionsByStudent";
import { getEnrollments, getEnrollmentsByStudent } from "../services/school/student/getEnrollments";

export const useGetSubscriptionsByStudentQuery = (pagedRequest?: PagedRequestType,options:any= null) => {
    return useQuery([Key_subscriptions, JSON.stringify(pagedRequest)], () => getSubscriptionsByStudent (pagedRequest),options?{...options}:{});
  };


  export const useGetEnrollmentsByStudentQuery = (pagedRequest?: PagedRequestType,options:any= null) => {
    return useQuery([Key_enrollments, JSON.stringify(pagedRequest)], () => getEnrollmentsByStudent (pagedRequest),options?{...options}:{});
  };
